<template>
  <div class="info-box">
    <div class="flex-1 overflow-y-auto pr-3">
      <div
        class="flex gap-x-8 h-12 rounded px-5"
        style="background-color: #f3f9f6"
      >
        <c_cell title="应收款">
          <template #default>
            <c_money
              :value="state.amountStatistic?.totalAmount"
              :key="state.amountStatistic?.totalAmount"
              color="#000"
              :prefix="false"
            />
          </template>
        </c_cell>
        <c_cell title="已收款">
          <template #default>
            <c_money
              :value="state.amountStatistic?.totalAmount"
              :key="state.amountStatistic?.totalAmount"
              color="#080"
              :prefix="false"
            />
          </template>
        </c_cell>
        <c_cell title="已申请开票金额">
          <template #default>
            <c_money
              :value="state.amountStatistic?.totalAmount"
              :key="state.amountStatistic?.totalAmount"
              color="#ffa500"
              :prefix="false"
            />
          </template>
        </c_cell>
      </div>
      <div class="mt-3">
        <div
          class="grid gap-x-5 gap-y-3"
          style="grid-template-columns: auto 1fr"
        >
          <c_cell title="开票主体" :value="state.info?.invoice_entity" />
          <li class="gap-x-10 flex">
            <c_cell title="开票种类">
              <c_status
                arrName="Invoice_Type"
                :value="state.info?.invoice_type"
                :key="state.info?.invoice_type"
              />
            </c_cell>
            <c_cell title="开票金额">
              <template #default>
                <c_money
                  :value="state.info?.amount"
                  :key="state.info?.amount"
                  bold
                  :prefix="false"
                  :size="16"
                />
              </template>
            </c_cell>
          </li>
          <c_cell title="发票抬头" :value="state.info?.invoice_title" />
          <c_cell title="纳税人识别号" :value="state.info?.tax_no" />
          <c_cell title="电话号码" :value="state.info?.phone || '-'" />
          <c_cell title="单位地址" :value="state.info?.address || '-'" />
          <c_cell title="开户银行" :value="state.info?.opening_bank || '-'" />
          <c_cell title="银行账户" :value="state.info?.bank_account || '-'" />
          <c_cell title="备注" :value="state.info?.remark || '-'" />
        </div>
        <el-form
          :model="state.kaipiao"
          label-width="auto"
          label-position="top"
          ref="kaipiaoDom"
          size="large"
          class="mt-3"
          v-if="
            $base.btn_status?.发票管理?.开票?.includes(state.info?.status) &&
            props.from == 'kaipiao'
          "
        >
          <ul class="flex items-center gap-x-1">
            <li class="w-1 bg-green-700 rounded-md h-3">&nbsp;</li>
            <strong>出票信息</strong>
          </ul>
          <ul class="items-center gap-x-3 flex">
            <el-form-item
              label="发票号"
              prop="invoice_no"
              :rules="[
                { required: true, message: '请输入发票号', trigger: 'blur' },
              ]"
            >
              <el-input v-model="state.kaipiao.invoice_no"></el-input>
            </el-form-item>
            <el-form-item
              label="开票日期"
              prop="invoice_date"
              :rules="[
                { required: true, message: '请输入开票日期', trigger: 'blur' },
              ]"
            >
              <el-date-picker
                v-model="state.kaipiao.invoice_date"
                type="date"
                placeholder=""
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
          </ul>
          <el-form-item label="开票备注">
            <el-input
              v-model="state.kaipiao.invoice_remark"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="附件">
            <c_UploadFile
              class="!w-full"
              :value="state.kaipiao.files"
              @change="
                (data) => {
                  state.kaipiao.files = data;
                }
              "
            />
          </el-form-item>
        </el-form>
        <el-form
          :model="state.daokuan"
          label-width="auto"
          label-position="top"
          ref="daokuanDom"
          size="large"
          class="mt-3"
          v-if="
            $base.btn_status?.发票管理?.标记到款?.includes(
              state.info?.status,
            ) && props.from == 'daokuan'
          "
        >
          <ul class="flex items-center gap-x-1">
            <li class="w-1 bg-green-700 rounded-md h-3">&nbsp;</li>
            <strong>到款信息</strong>
          </ul>
          <ul class="items-center gap-x-3 flex">
            <el-form-item label="到款流水">
              <el-input v-model="state.daokuan.receipt_sn"></el-input>
            </el-form-item>
            <el-form-item label="到款日期">
              <el-date-picker
                v-model="state.daokuan.receipt_date"
                type="date"
                placeholder=""
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
          </ul>
          <el-form-item label="到款备注">
            <el-input
              v-model="state.daokuan.receipt_remark"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="附件">
            <c_UploadFile
              class="!w-full"
              :value="state.daokuan.files"
              @change="
                (data) => {
                  state.daokuan.files = data;
                }
              "
            />
          </el-form-item>
        </el-form>
        <el-form
          :model="state.hongchong"
          label-width="auto"
          label-position="top"
          ref="hongchongDom"
          size="large"
          class="mt-3"
          v-if="
            $base.btn_status?.发票管理?.红冲?.includes(state.info?.status) &&
            props.from == 'hongchong'
          "
        >
          <ul class="flex items-center gap-x-1">
            <li class="w-1 bg-green-700 rounded-md h-3">&nbsp;</li>
            <strong>红冲信息</strong>
          </ul>
          <ul class="items-center gap-x-3 flex">
            <el-form-item label="发票号">
              <el-input v-model="state.hongchong.reverse_invoice_no"></el-input>
            </el-form-item>
            <el-form-item label="红冲日期">
              <el-date-picker
                v-model="state.hongchong.reverse_invoice_date"
                type="date"
                placeholder=""
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
          </ul>
          <el-form-item label="红冲备注">
            <el-input
              v-model="state.hongchong.reverse_invoice_remark"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="附件">
            <c_UploadFile
              class="!w-full"
              :value="state.hongchong.files"
              @change="
                (data) => {
                  state.hongchong.files = data;
                }
              "
            />
          </el-form-item>
        </el-form>
        <ul class="font-bold text-sm flex items-center gap-x-1 mt-3 mb-3">
          <li
            style="
              width: 3px;
              background-color: var(--el-color-primary);
              height: 12px;
              border-radius: 10px;
            "
          >
            &nbsp;
          </li>
          操作记录
        </ul>
        <el-timeline class="!text-xs" style="padding-left: 5px">
          <el-timeline-item
            v-for="item in state.meetingInvoiceLogList"
            :key="item"
            type="primary"
            hide-timestamp
          >
            <div class="flex gap-x-3">
              <text>{{ item.create_time }}</text>
              <text>{{ item.add_admin_name }}</text>
              <text class="text-gray-400" style="margin-left: -12px">
                {{ "/" + item.add_department_name }}
              </text>
              <text class="text-primary">{{ item.title }}</text>
            </div>
            <el-card class="mt-2" shadow="always" v-if="item.status == 2">
              <ul class="flex gap-x-3">
                <c_cell title="发票号" :value="state.info?.invoice_no" />
                <c_cell title="开票日期" :value="state.info?.invoice_date" />
                <c_cell title="开票备注" :value="state.info?.invoice_remark" />
              </ul>
              <c_cell
                title="附件"
                class="mt-1"
                v-if="state.info?.invoice_attachment?.length > 0"
              >
                <c_UploadFile
                  :key="state.info?.invoice_attachment"
                  :value="state.info?.invoice_attachment"
                  :showAdd="false"
                  :showText="true"
                />
              </c_cell>
            </el-card>
            <el-card class="mt-2" shadow="always" v-else-if="item.status == 3">
              <ul class="flex gap-x-3">
                <c_cell title="到款流水" :value="state.info?.receipt_sn" />
                <c_cell title="到款日期" :value="state.info?.receipt_date" />
                <c_cell title="到款备注" :value="state.info?.receipt_remark" />
              </ul>
              <c_cell
                title="附件"
                class="mt-1"
                v-if="state.info?.receipt_attachment?.length > 0"
              >
                <c_UploadFile
                  :key="state.info?.receipt_attachment"
                  :value="state.info?.receipt_attachment"
                  :showAdd="false"
                  :showText="true"
                />
              </c_cell>
            </el-card>
            <el-card class="mt-2" shadow="always" v-else-if="item.status == 4">
              <ul class="flex gap-x-3">
                <c_cell
                  title="红冲发票号"
                  :value="state.info?.reverse_invoice_no"
                />
                <c_cell
                  title="红冲日期"
                  :value="state.info?.reverse_invoice_date"
                />
                <c_cell
                  title="红冲备注"
                  :value="state.info?.reverse_invoice_remark"
                />
              </ul>
              <c_cell
                title="附件"
                class="mt-1"
                v-if="state.info?.reverse_invoice_attachment?.length > 0"
              >
                <c_UploadFile
                  :key="state.info?.reverse_invoice_attachment"
                  :value="state.info?.reverse_invoice_attachment"
                  :showAdd="false"
                  :showText="true"
                />
              </c_cell>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <div class="submit-box px-2.5">
      <!-- <el-button
        v-if="$base.btn_status?.发票管理?.作废?.includes(state.info?.status)"
        type="danger"
        size="large"
        @click="onZuoFei()"
      >
        作废
      </el-button> -->
      <el-button
        v-if="
          $base.btn_status?.发票管理?.开票?.includes(state.info?.status) &&
          props.from == 'kaipiao'
        "
        type="primary"
        size="large"
        @click="onKaiPiao()"
      >
        确认出票
      </el-button>
      <el-button
        v-if="
          $base.btn_status?.发票管理?.标记到款?.includes(state.info?.status) &&
          props.from == 'daokuan'
        "
        type="warning"
        size="large"
        @click="onDaoKuan()"
      >
        确认到款
      </el-button>
      <el-button
        v-if="
          $base.btn_status?.发票管理?.红冲?.includes(state.info?.status) &&
          props.from == 'hongchong'
        "
        type="danger"
        size="large"
        @click="onHongChong()"
      >
        红冲
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  invoice_search,
  invoice_do,
  invoice_receipt,
  invoice_invalid,
  invoice_reverse,
} from "@/http/invoice";
import { ElMessageBox, dayjs } from "element-plus";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
    from: String, //列表操作按钮    kaipiao-开票   daokuan-标记到款   hongchong-红冲   chakan-查看
  },
  setup(props, { emit }) {
    const kaipiaoDom = ref(null);
    const daokuanDom = ref(null);
    const hongchongDom = ref(null);
    const state = reactive({
      info: {},
      kaipiao: { id: props.id, invoice_date: dayjs().format("YYYY-MM-DD") },
      daokuan: { id: props.id, receipt_date: dayjs().format("YYYY-MM-DD") },
      hongchong: {
        id: props.id,
        reverse_invoice_date: dayjs().format("YYYY-MM-DD"),
      },
    });
    onMounted(() => {
      if (props.id) {
        invoice_search(props.id).then((res) => {
          if (res.status == 200) {
            const {
              amountStatistic,
              info,
              meetingCollectedPlanStatistic,
              meetingInvoiceLogList,
            } = res.data?.data || {};
            state.amountStatistic = amountStatistic;
            state.info = info;
            state.meetingCollectedPlanStatistic = meetingCollectedPlanStatistic;
            state.meetingInvoiceLogList = meetingInvoiceLogList;
          }
        });
      }
    });

    //开票
    const onKaiPiao = () => {
      kaipiaoDom.value.validate((valid) => {
        if (valid) {
          state.kaipiao.invoice_attachment = state.kaipiao.files?.map(
            (item) => item.id,
          );

          ElMessageBox.confirm(`您确定开票吗？`, "确认开票", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            dangerouslyUseHTMLString: true,
            cancelButtonClass: "is-plain",
          }).then(() => {
            invoice_do(state.kaipiao).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          });
        }
      });
    };

    //开票
    const onDaoKuan = () => {
      daokuanDom.value.validate((valid) => {
        if (valid) {
          state.daokuan.receipt_attachment = state.daokuan.files?.map(
            (item) => item.id,
          );

          ElMessageBox.confirm(`您确定标记到款吗？`, "标记到款", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            dangerouslyUseHTMLString: true,
            cancelButtonClass: "is-plain",
          }).then(() => {
            invoice_receipt(state.daokuan).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          });
        }
      });
    };

    //开票
    const onHongChong = () => {
      hongchongDom.value.validate((valid) => {
        if (valid) {
          state.hongchong.reverse_invoice_attachment =
            state.hongchong.files?.map((item) => item.id);

          ElMessageBox.confirm(`您确定红冲发票吗？`, "红冲发票", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            dangerouslyUseHTMLString: true,
            cancelButtonClass: "is-plain",
          }).then(() => {
            invoice_reverse(state.hongchong).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          });
        }
      });
    };

    //作废
    const onZuoFei = () => {
      ElMessageBox.prompt(
        `您确定<strong style='color:var(--el-color-danger)'>作废发票</strong>吗？`,
        "提示",
        {
          confirmButtonText: "确定作废",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "el-button--danger",
          cancelButtonClass: "is-plain",
          inputPattern: /\S/,
          inputType: "textarea",
          inputPlaceholder: "请输入作废说明",
          inputErrorMessage: "请输入作废说明",
        },
      ).then(({ value }) => {
        invoice_invalid({
          id: props.id,
          invalid_msg: value,
        }).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              emit("close", true);
            }, 500);
          });
        });
      });
    };

    return {
      state,
      props,
      kaipiaoDom,
      daokuanDom,
      hongchongDom,
      onKaiPiao,
      onDaoKuan,
      onZuoFei,
      onHongChong,
    };
  },
};
</script>
<style type="scss"></style>
